import {
  AfterViewInit,
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CardService } from '../../../authenticated/services/card.service';
import { Card } from '../../models/card-models/card';
import { first } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'business-header',
  templateUrl: './business-header.component.html',
  styleUrls: ['./business-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BusinessHeaderComponent implements OnInit {
  @Input() isAuthenticated: boolean;

  componentDestroyed = new Subject<void>();
  currentRewardCard: Card;
  navLink: string;
  authenticated: boolean;
  menuItems = [
    { name: 'Dashboard', route: 'dashboard' },
    { name: 'Redeem', route: 'redeem-points' },
    { name: 'Vehicles', route: 'gmvehicles' }
  ];
  constructor(
    private readonly cardService: CardService,
    private readonly apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.cardService
      .getCurrentCard()
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(card => {
        this.currentRewardCard = card;
        // The card is null/undefined after sign-out (clearCards) or when no
        // matching card is found, so there is nothing to route from.
        if (!card) {
          return;
        }
        if (card.path === 'gmb') {
          this.navLink = '/dashboard';
        } else {
          this.navLink = '/summary';
        }
        this.authenticated = true;
      });
  }

  login(_window: Window = window): void {
    this.apiService
      .getSsoUrl('')
      .pipe(first())
      .subscribe(redirectUrl => {
        _window.location.href = redirectUrl.result;
      });
  }

  signOut(_window): void {
    _window = _window || window;
    this.apiService
      .getLogoutUrl()
      .pipe(first())
      .subscribe(redirectUrl => {
        this.cardService.clearCards();
        _window.location.href = redirectUrl.result;
      });
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next();
    this.componentDestroyed.unsubscribe();
  }
}
